import React from 'react';
import {PersistGate} from 'redux-persist/integration/react';
import {appPersistor} from '../../../../store/configureStore';

export interface PersistProviderProps {
  children: React.ReactNode;
}

/** Should be placed after store provider */
const PersistProvider = ({children}: PersistProviderProps) => {
  return (
    <PersistGate loading={null} persistor={appPersistor}>
      {children}
    </PersistGate>
  );
};

export default PersistProvider;
